module.exports = "<footer class=\"footer\">\n  <div class=\"container\">\n    <div class=\"row\">\n      \n    </div>\n  </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/footer/footer.component.html
// module id = ./src/app/component/blocks/footer/footer.component.html
// module chunks = main